import SelectLanguage from './SelectLanguage.jsx';

export default SelectLanguage;
